// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 3H18V21H6V3ZM1 5H4.5V19H1V17H2.5V7H1V5ZM19.5 5H23V7H21.5V17H23V19H19.5V5Z"}}]};

const SlideshowFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'slideshow-filled',
    ref,
    icon: element,
  },
));

SlideshowFilledIcon.displayName = 'SlideshowFilledIcon';

export default SlideshowFilledIcon;
